import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
/**
 * NOTE: Don't use this button in your applications.
 * If you need a button, use `<Button />` from https://reactstrap.github.io/components/buttons/
 */
export var BootstrapButton = styled.button.attrs(function (props) {
    var buttonClasses = ['btn', 'd-flex', 'align-items-center', "btn-" + props.color];
    if (props.size)
        buttonClasses.push("btn-" + props.size);
    if (props.block)
        buttonClasses.push('btn-block justify-content-center');
    return {
        className: buttonClasses.join(' '),
        'aria-label': props.ariaLabel,
        disabled: props.disabled,
    };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
BootstrapButton.defaultProps = {
    color: 'primary',
    ariaLabel: 'close',
};
var templateObject_1;
//# sourceMappingURL=BootstrapButton.js.map